var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tab-content-presentation extensible-edit-view"},[(_vm.editViewComponentForSlideType)?_c(_vm.editViewComponentForSlideType,{tag:"component"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }